module.exports = __webpack_public_path__ + "static/media/Cowboy Costume.84637e62.jpg";